import tippy from "tippy.js";

// Set default props for all tippy instances
// Enable interactive by default to have consistent UX for our tooltip
tippy.setDefaultProps({
  interactive: false
});

const directive = {
  mounted: function (el, binding) {
    var value;
    if (binding.value) {
      value =
        typeof binding.value === "string"
          ? { content: binding.value }
          : binding.value;
      try {
        if (value.content) {
          tippy(el, value);

          // Remove tabindex to fix accessibility when interactive is false
          if (value.interactive) {
            el.setAttribute("tabindex", "0");
          }

          const al = el.getAttribute("aria-label");
          if (
            //set aria-label only if it is not set already
            al === null ||
            al === undefined
          ) {
            el.setAttribute("aria-label", value.content);
          }
        }
      } catch (err) {
        console.log(
          "Error while rendering custom 'tooltip' directive - most likely the passed object is wrong",
          err
        );
      }
    }
  }
};

export default directive;
